import React, { Component} from 'react'
import { utils_tool, component_tool } from "@/tool";
const { pstmsg } = utils_tool
import login from './login'
import table from './table'
import list from './list'
export class index extends Component {

  constructor(props){
    super(props);
    this.comps = [ table, login, list ]
    this.state = {
      win: null
    }
  }

  // getArrEqual = (arr1, arr2) => {
  //   let newArr = [];
  //   for (let i = 0; i < arr2.length; i++) {
  //     for (let j = 0; j < arr1.length; j++) {
  //       if(arr1[j] === arr2[i]){
  //         newArr.push(arr1[j]);
  //       }
  //   }
  //  }
  //  return newArr;
  // }

  componentDidMount() {
    this.setState({
      win: document.getElementById('childFrame')
    })
    
    // this.pstmsg.loaded((e)=>{
    //   // e.emit('loginResult',666)
    //   e.on('login',(e) => {
    //     that.showModal()
    //   })
    // })

    this.messageEvent.on('openWindow',()=>{
      var w = window.open('http://baidu.com','15','width=600, height=500');
      w.focus();
    })
  }

  componentWillUnmount() {
    this.messageEvent.destroy()
  }

  render() {
    const { win } = this.state
    this.messageEvent = new pstmsg(win, 'http://xiaohuangmao.gitee.io')
    const cp = win ? this.comps.map(C=>(
      <C key={ C } messageEvent = { this.messageEvent } />
    )) : null
    
    return ( 
        <>
            { cp }
            <iframe id = "childFrame" title="childFrame" src="http://xiaohuangmao.gitee.io/layui-demo/index.html" width="100%" height="1200" frameBorder="no"  /> 
        </>
    )
  }
}


export default index
